module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "on-demand-wrapper"
  }, [_c('h1', {
    staticClass: "main-title individual grid-container"
  }, [_vm._v("Ross on Demand")]), _vm._v(" "), (_vm.featured) ? _c('div', {
    staticClass: "show-container brain-dump"
  }, [_c('div', {
    staticClass: "grid-container grid-100"
  }, [_c('div', {
    staticClass: "grid-100 grid-parent buy-all"
  }, [(_vm.featured) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vimeo.com/ondemand/rossnoble"
    }
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), (_vm.featured) ? _c('div', {
    key: _vm.featured.video_url,
    staticClass: "grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video-item grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video-header grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('iframe', {
    attrs: {
      "id": "main-video",
      "src": _vm.featured.video_url,
      "width": "640",
      "height": "352",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.featured.title.rendered))])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.notFeatured), function(video, index) {
    return _c('div', {
      key: video.video_url,
      staticClass: "grid-48 grid-parent",
      class: {
        'margin-left-4': index % 2 !== 0
      }
    }, [_c('div', {
      staticClass: "video-item grid-100 grid-parent"
    }, [_c('div', {
      staticClass: "video-header grid-100 grid-parent"
    }, [_c('div', {
      staticClass: "video"
    }, [_c('iframe', {
      attrs: {
        "id": "main-video",
        "src": video.video_url,
        "width": "640",
        "height": "352",
        "frameborder": "0",
        "webkitallowfullscreen": "",
        "mozallowfullscreen": "",
        "allowfullscreen": ""
      }
    })])]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(video.title.rendered))]), _vm._v(" "), _c('a', {
      attrs: {
        "target": "_blank",
        "href": video.link
      }
    }, [_c('div', {
      staticClass: "buy-cta white"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(video.price))])])]), _vm._v(" "), _c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.tourData.all_video_link
      }
    }, [_vm._m(1, true)])])])
  }), _vm._v(" "), (_vm.videos.length > 0) ? _c('original-content') : _vm._e()], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy-cta all white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("All Videos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy-cta all white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("All Videos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d55f461","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnDemand.vue
// module id = 281
// module chunks = 0